import { connect } from 'react-redux';

import { userManagementActions } from "dataflow/distributorPortal/actions";

import UserUpdatePresentation from './UserUpdatePresentation';

function mapStateToProps(state) {
    const { 
        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList,

        isUserRecordUpdatedSuccessfully,

        addUser_requesting, updateUser_requesting,

        userPermissions
    } = state.distributorPortal_userManagementReducers;

    const {
        userInfo
    } = state.distributorPortal_authenticationReducers;
    
	return {
        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList,

        isUserRecordUpdatedSuccessfully,

        addUser_requesting, updateUser_requesting,
        
        userPermissions,

        userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateUser: (userInfo, userGroups) => { dispatch(userManagementActions.updateUser(userInfo, userGroups)); },
        addUser: (userInfo, userGroups) => { dispatch(userManagementActions.addUser(userInfo, userGroups)); },
    };
}

const UserUpdate = connect(mapStateToProps, mapDispatchToProps)(UserUpdatePresentation);

export default UserUpdate;